const Message = new Map([
  [1, 'ResultMessage.Error'],
  [4, 'ResultMessage.InWork'],
  [5, 'ResultMessage.NotFound'],
  [11, 'ResultMessage.NotFound'],
]);

export default { Message };
